import updateDayType from './dayType/updateDayType';
import createDayType from './dayType/createDayType';
import deleteDayType from './dayType/deleteDayType';
import createTour from './tour/createTour';
import updateTour from './tour/updateTour';
import deleteTour from './tour/deleteTour';
import createMeal from './meal/createMeal';
import createTourPreReq from './tour/createTourPreReq';
import * as createAssignment from './assignment/createAssignment';
import * as deleteAssignment from './assignment/deleteAssignment';
import * as updateAssignment from './assignment/updateAssignment';
import * as deleteJob from './job/deleteJob';
import * as updateJob from './job/updateJob';
import updateMeal from './meal/updateMeal';
import deleteMeal from './meal/deleteMeal';
import createTourPayTransaction from './tour/payTransaction/createTourPayTransaction';
import updateTourPayTransaction from './tour/payTransaction/updateTourPayTransaction';
import deleteTourPayTransaction from './tour/payTransaction/deleteTourPayTransaction';
import createTourIndicator from './tour/indicator/createTourIndicator';
import updateTourIndicator from './tour/indicator/updateTourIndicator';
import deleteTourIndicator from './tour/indicator/deleteTourIndicator';
import createTourActivityFlag from './tour/activityFlag/createTourActivityFlag';
import updateTourActivityFlag from './tour/activityFlag/updateTourActivityFlag';
import deleteTourActivityFlag from './tour/activityFlag/deleteTourActivityFlag';

const CRUD = {
  updateDayType,
  createDayType,
  deleteDayType,
  createTour,
  updateTour,
  deleteTour,
  createMeal,
  createTourPreReq,
  createAssignment,
  deleteAssignment,
  updateAssignment,
  deleteJob,
  updateJob,
  updateMeal,
  deleteMeal,
  createTourPayTransaction,
  updateTourPayTransaction,
  deleteTourPayTransaction,
  createTourIndicator,
  updateTourIndicator,
  deleteTourIndicator,
  createTourActivityFlag,
  updateTourActivityFlag,
  deleteTourActivityFlag
};


export default CRUD;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/index.js